import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * Reusable header component for all Ideas Management pages
 * Provides consistent breadcrumbs, title, and description
 */
const IdeasPageHeader = ({ 
  title, 
  description, 
  breadcrumbPath = "Ideas Management",
  children 
}) => {
  return (
    <div style={{ marginBottom: '32px' }}>
      {/* Breadcrumb */}
      <div style={{
        fontSize: '14px',
        color: 'var(--cares-text-label)',
        marginBottom: '12px',
        paddingTop: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <span style={{ color: 'var(--cares-text-note)' }}>Home</span>
        <ChevronRight size={14} style={{ color: 'var(--cares-text-note)' }} />
        <span style={{ color: 'var(--cares-text-note)' }}>Ideas Management</span>
        {breadcrumbPath !== "Ideas Management" && (
          <>
            <ChevronRight size={14} style={{ color: 'var(--cares-text-note)' }} />
            <span style={{ color: 'var(--cares-text-3)', fontWeight: '500' }}>{breadcrumbPath}</span>
          </>
        )}
      </div>

      {/* Page Title and Description */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'flex-start', 
        justifyContent: 'space-between',
        gap: '24px'
      }}>
        <div style={{ flex: 1 }}>
          <h1 style={{
            fontSize: '32px',
            fontWeight: '700',
            color: 'var(--cares-text-1)',
            margin: '0 0 8px 0',
            lineHeight: '1.2'
          }}>
            {title}
          </h1>
          {description && (
            <p style={{
              fontSize: '16px',
              color: 'var(--cares-text-label)',
              margin: 0,
              lineHeight: '1.5'
            }}>
              {description}
            </p>
          )}
        </div>

        {/* Optional action buttons or content */}
        {children && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px' 
          }}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default IdeasPageHeader;

